var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4091_7320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6953 84C31.246 87.5656 33.8042 90.6007 37.0559 92.7324C40.3076 94.8642 44.1111 95.9998 47.9993 95.9998C51.8875 95.9998 55.691 94.8642 58.9427 92.7324C62.1944 90.6007 64.7527 87.5656 66.3033 84H29.6953Z",
    fill: "#314155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5672 50.1947L82.6232 27.3027C80.3995 19.2961 75.5648 12.2618 68.8867 7.31675C62.2086 2.37166 54.0699 -0.200787 45.7629 0.00785488C37.4558 0.216497 29.4565 3.19426 23.0351 8.46836C16.6137 13.7425 12.1382 21.0106 10.3192 29.1187L4.92723 51.2667C4.21057 54.2098 4.17174 57.2771 4.81367 60.2373C5.45561 63.1975 6.76155 65.9733 8.63292 68.3551C10.5043 70.7368 12.8922 72.6625 15.6165 73.9866C18.3408 75.3107 21.3302 75.9987 24.3592 75.9987H70.4272C73.5502 75.9989 76.6297 75.2676 79.4193 73.8637C82.2088 72.4597 84.6308 70.422 86.4913 67.9137C88.3518 65.4055 89.5991 62.4964 90.1332 59.4195C90.6673 56.3425 90.4735 53.1833 89.5672 50.1947V50.1947Z",
    fill: "#314155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_7320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChats);
export default __webpack_public_path__ + "static/media/noChats.27d97056.svg";
export { ForwardRef as ReactComponent };